import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Select as MatSelect } from 'react-materialize';

const Content = styled.div`
    display: flex;
    margin: ${props => props.margin ? props.margin : '0 0'};
    // react-materialize always wraps Select in a div.input-field, even with
    // noLayout, carrying materialize's own 1rem top/bottom margin and no
    // width - reset both so spacing is only driven by the margin prop above
    // and the select fills the row like the other form fields.
    .input-field {
        width: 100%;
        margin: 0;
    }
`;

// iOS fix: materialize's Dropdown closes itself on the `touchend` that reaches
// document.body, but iOS dispatches the synthetic `click` ~300ms later, once
// the list is already closing/moving - so the tap is lost or lands on another
// option. Swallow `touchend` inside select dropdowns (capture phase, before it
// reaches body); the `click` still selects the option and closes the dropdown.
// `touchmove` is swallowed too, otherwise materialize's isTouchMoving flag
// (only reset on touchend) would keep the dropdown open after scrolling it.
if (typeof document !== 'undefined' && !window.__selectTouchFix) {
    window.__selectTouchFix = true;
    const swallowInSelectDropdown = (e) => {
        if (e.target.closest && e.target.closest('.dropdown-content.select-dropdown')) {
            e.stopPropagation();
        }
    };
    document.addEventListener('touchend', swallowInSelectDropdown, true);
    document.addEventListener('touchmove', swallowInSelectDropdown, true);
}

const Select = (props) => {
    return (
        <Content margin={props.margin}>
            <MatSelect
                id={props.id}
                name={props.name}
                multiple={props.multiple}
                noLayout
                value={props.value}
                onChange={props.onChange}
                options={props.options}>
                {props.children}
            </MatSelect>
        </Content>
    );
}

Select.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    multiple: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    margin: PropTypes.string,
    options: PropTypes.object,
    onChange: PropTypes.func,
    children: PropTypes.any
}

export default Select;
